import { z } from 'zod'
import { SessionUserSchema } from '@shared/lib/auth/session-types'
import { isValidPhone } from '@shared/lib/validation/documents'

export const AuthResponseSchema = z.object({
  token: z.string().min(1),
  user: SessionUserSchema,
})

export type AuthResponse = z.infer<typeof AuthResponseSchema>

export const LoginInputSchema = z.object({
  email: z.string().email('Informe um e-mail válido.'),
  password: z.string().min(1, 'Informe sua senha.'),
  recaptchaToken: z.string().optional(),
})

export type LoginInput = z.infer<typeof LoginInputSchema>

export const RegisterInputSchema = z
  .object({
    referralToken: z
      .string()
      .regex(/^[A-Za-z0-9_-]{32}$/)
      .optional(),
    termsAccepted: z.boolean().refine((value) => value, 'Aceite os termos para criar a conta.'),
    termsVersion: z.string().min(1, 'Carregando os termos. Tente novamente.'),
    name: z.string().min(3, 'Informe seu nome completo.'),
    email: z.string().email('Informe um e-mail válido.'),
    phone: z
      .string()
      .trim()
      .refine((value) => value === '' || isValidPhone(value), 'Telefone inválido.')
      .transform((value) => (value === '' ? undefined : value))
      .optional(),
    password: z.string().min(8, 'Use ao menos 8 caracteres.'),
    confirmPassword: z.string().min(1, 'Confirme a senha.'),
    recaptchaToken: z.string().optional(),
  })
  .refine((value) => value.password === value.confirmPassword, {
    path: ['confirmPassword'],
    message: 'As senhas não coincidem.',
  })

export type RegisterInput = z.infer<typeof RegisterInputSchema>

export const SignupTermsSchema = z.object({
  version: z.string(),
  consentLabel: z.string(),
  consentText: z.string(),
  vendepayTermsUrl: z.string().url(),
  vendepayPrivacyUrl: z.string().url(),
  stripeAgreementUrl: z.string().url(),
  stripeServicesUrl: z.string().url(),
  stripePrivacyUrl: z.string().url(),
  acquirerDisclosure: z.string(),
})
export type SignupTerms = z.infer<typeof SignupTermsSchema>

export const ForgotPasswordInputSchema = z.object({
  email: z.string().email('Informe um e-mail válido.'),
  recaptchaToken: z.string().optional(),
})

export type ForgotPasswordInput = z.infer<typeof ForgotPasswordInputSchema>

export const ResetPasswordInputSchema = z.object({
  token: z.string().min(1),
  password: z.string().min(8, 'Use ao menos 8 caracteres.'),
})

export type ResetPasswordInput = z.infer<typeof ResetPasswordInputSchema>

export const VerifyEmailInputSchema = z.object({
  token: z.string().min(1),
})

export type VerifyEmailInput = z.infer<typeof VerifyEmailInputSchema>
